import { useContext, useState } from "react";
import { AppContext } from "../../../context/AppContextProvider";
import { Button, Space, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { updateAuthDetails } from "../../../network/network";
import StoreConfiguration from "../../Content/StoreConfiguration/StoreConfiguration";
import { handleApiError } from "../../../utils/errorHandler";

const RegisterConfirmed = () => {
  const { authUser, setAuthUser } = useContext(AppContext);
  const { t } = useTranslation();

  const [showStoreConfig, setShowStoreConfig] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSkip = async () => {
    try {
      setLoading(true);

      const response = await updateAuthDetails();

      if (response.data && response.data.success === true) {
        setAuthUser(response.data.data.user);
        return;
      }

      if (response?.data?.success === false) {
        handleApiError(response, t);
      }
    } catch (error) {
      handleApiError(error, t);
    } finally {
      setLoading(false);
    }
  };

  if (showStoreConfig) {
    return <StoreConfiguration isOnboarding />;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--color-primary-soft)",
      }}
    >
      <Spin spinning={loading}>
        <div
          style={{
            textAlign: "center",
            padding: "48px 40px",
            backgroundColor: "var(--color-white)",
            borderRadius: "16px",
            boxShadow: "0 4px 20px var(--color-shadow-soft)",
            border: "1px solid var(--color-border)",
            maxWidth: "480px",
            width: "100%",
          }}
        >
          <h1
            style={{ fontSize: "24px", fontWeight: 700, marginBottom: "10px" }}
          >
            {t("hi")} {authUser.name}, {t("account_successfully_created")}
          </h1>

          <img
            src="/images/check_mark.gif"
            alt={t("success")}
            style={{ width: "120px", margin: "20px auto", display: "block" }}
          />

          <p
            style={{
              marginTop: "12px",
              marginBottom: "32px",
              color: "var(--color-heading)",
              fontSize: "16px",
              lineHeight: 1.6,
            }}
          >
            {t("details_activate_company")}
          </p>

          <Space size={12}>
            <Button type="default" loading={loading} onClick={handleSkip}>
              {t("skip")}
            </Button>

            <Button type="primary" onClick={() => setShowStoreConfig(true)}>
              {t("fill_the_details")}
            </Button>
          </Space>
        </div>
      </Spin>
    </div>
  );
};

export default RegisterConfirmed;
